export default "__VITE_ASSET__CXuz58PF__"